import { Icon } from '@dbt-labs/sourdough';

import { WarehouseEntityType } from '@/__generated__/graphql';
import { entityToIconMap, pluralizedCapitalizedEntityNames } from '@/util/entityType';

type LocationDetailsProps = {
  fqn: string | null;
  entityType: WarehouseEntityType;
};

export const LocationDetails = ({ fqn, entityType }: LocationDetailsProps) => {
  if (!fqn) return null;

  const parts = fqn.split('.');
  if (parts.length < 2) return null;

  const [database, schema] = parts;
  return (
    <div className="flex gap-2">
      <span>
        <Icon ryecon={entityToIconMap[WarehouseEntityType.Database]} className="mr-1" />
        {database}
      </span>
      /
      <span>
        <Icon ryecon={entityToIconMap[WarehouseEntityType.Schema]} className="mr-1" />
        {schema}
      </span>
      /
      <span>
        <Icon ryecon={entityToIconMap[entityType]} className="mr-1" />
        {pluralizedCapitalizedEntityNames[entityType]}
      </span>
    </div>
  );
};
